<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h1>Example Page</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <app-example-component></app-example-component>
        </div>
    </div>
</div>